import MUIBadge, { BadgeProps } from '@mui/material/Badge'

export const Badge = (props: BadgeProps) => {
  return <MUIBadge {...props} />
}
